function isEmptyObject(obj: Record<string, unknown>): boolean {
  return Object.keys(obj).length === 0 || Object.values(obj).some(v => v === undefined || v === null || v === '');
}

export default isEmptyObject;
